import 'reflect-metadata';
import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import { PortalType } from '@studyportals/domain-client';
import { OrganisationsSearch } from './OrganisationsSearch';
import { ModalManager } from '@studyportals/modal';

declare global {
	interface Window {
		EventAggregationService: IEventAggregationService | undefined;
		rollbar: typeof Rollbar;
		PortalType: PortalType;
		PortalMap: Record<PortalType, string>;
		prerenderReady: boolean;
		ModalManager: ModalManager;
		Shared: {
			breakpoints(points: string[], callback?: () => void): boolean;
			debounce(callback: () => void, delay: number): () => void;
		};
	}
}

const bootstrap = (): Promise<void> => {
	OrganisationsSearch.initialize();

	return Promise.resolve();
};

void bootstrap();
